import {
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import { envAwarePost } from '../util/util'

export const updateCustomApp = createAsyncThunk(
	"updateCustomApp",
	async (payload) => envAwarePost("/api/customApp/", payload)
);

export const editCustomApp = createAsyncThunk(
	"editCustomApp",
	async (payload) => envAwarePost("/api/customApp/", {
		action:'editCustomApp',
		...payload
	})
)

export const getCustomAppDetails = createAsyncThunk(
	"getCustomAppDetails",
	async () => envAwarePost("/api/customApp/", {
		action:'getCustomAppDetails'
	})
)

const slice = createSlice({
	name: 'branding',
	initialState: {
		status: 'pending',
		backgroundColor: null,
		logo: null,
		textColor: null,
		branding: false,
		width: null,
		loading: false,
		//though the pwa requires a 512x512 and a 192x192 we only
		//show the 512 and generate the 192 in the background
		pwa_icon_512:null,
		pwa_name:null,
		pwa_short_name:null
	},
	reducers: {
		setBranding: (state, action) => {
			if (Boolean(action.payload)) {
				const { backgroundColor, textColor, logo, width } = action.payload
				state.status = 'ready'
				state.backgroundColor = backgroundColor
				state.logo = logo
				state.textColor = textColor
				state.width = width
			}
		},
		setLogo: (state,action)=>{
			// !!!!!! README !!!!!!
			//WARNING: random actions are typically NEVER okay
			//in reducers. BUT in this case, the logo url does not
			//change but the back end resource does. So we need
			//to force a re-render
			state.logo = `${action.payload}?v=${Math.random()}`
		}
	},
	extraReducers: {
		[getCustomAppDetails.fulfilled] : (state,action)=>{
			const keys = ['backgroundColor','logo','textColor','branding','width']
			keys.forEach(k=>{
				if (Boolean(action.payload.data[k])) state[k] = action.payload.data[k]
			})
			state.pwa_icon_512 = action.payload.data.web_app_details?.pwa_icon_512
			state.pwa_name = action.payload.data.web_app_details?.pwa_name
			state.pwa_short_name = action.payload.data.web_app_details?.pwa_short_name
		},
		[editCustomApp.pending] : (state,action)=>{
			const keys = [
				'backgroundColor',
				'logo',
				'textColor',
				'branding',
				'width',
				'pwa_icon_512',
				'pwa_name',
				'pwa_short_name'
			]
			keys.forEach(k=>{
				if (Boolean(action.meta.arg.update[k])) state[k] = action.meta.arg.update[k]
			})
		},

		[updateCustomApp.pending]: (state, action) => {
			if (action.meta.arg.logo) {
				state.logo = ""
			}
		},

		[updateCustomApp.fulfilled]: (state, action) => {
			if (action.payload.success === "1") {
				const { backgroundColor, textColor, width } = action.payload.data;
				const { logo } = action.payload.data
				state.backgroundColor = backgroundColor
				state.textColor = textColor
				state.width = width
				if (logo) {
					state.logo = logo
				}
			}
		}
	}
})

export const { setBranding,setLogo } = slice.actions

export default slice.reducer